import React from "react";
import {
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  Table,
  Paper,
  TableBody,
} from "@mui/material";
import PropTypes from "prop-types";
import style from "./style";

function CustomTable({ columns, rows, hasAction = false }) {
  return (
    <>
      <TableContainer component={Paper} sx={style.container}>
        <Table aria-label="collapsible table" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell
                  key={col.displayName}
                  align="left"
                  rowSpan={col.rowspan ? col.rowSpan : 1}
                  colSpan={col.colSpan ? col.colSpan : 1}
                  sx={style.tableHeadCell}
                >
                  {col.displayName}
                </TableCell>
              ))}
              {hasAction ? <TableCell sx={style.tableHeadCell} /> : null}
            </TableRow>
          </TableHead>
          <TableBody sx={style.tableBody}>{rows}</TableBody>
        </Table>
      </TableContainer>
      {/* {!rows.length ? (
        <Box style={style.emptyList}>
          <Typography>No record found</Typography>
        </Box>
      ) : null} */}
    </>
  );
}

const propTypes = {
  columns: PropTypes.arrayOf(PropTypes.objectOf()).isRequired,
  rows: PropTypes.arrayOf(PropTypes.element).isRequired,
  hasAction: PropTypes.bool,
};

const defaultProps = {
  hasAction: false,
};

CustomTable.propTypes = propTypes;
CustomTable.defaultProps = defaultProps;

export default CustomTable;
